import { useState, useCallback, useEffect } from 'react';
import { useInView } from 'react-intersection-observer';
import { useReviews } from './useReviews';
export const useReviewsModal = (facilityId) => {
    const [isOpen, setIsOpen] = useState(false);
    const { reviews, isLoading, error, hasMore, fetchReviews } = useReviews(facilityId);
    const { ref: sentinelRef, inView } = useInView({
        rootMargin: '100px',
    });
    const openModal = useCallback(() => {
        setIsOpen(true);
        if (reviews.length === 0) {
            fetchReviews();
        }
    }, [reviews.length, fetchReviews]);
    const closeModal = useCallback(() => {
        setIsOpen(false);
    }, []);
    useEffect(() => {
        if (inView && !isLoading && hasMore && isOpen) {
            fetchReviews();
        }
    }, [inView, isLoading, hasMore, isOpen, fetchReviews]);
    return {
        isOpen,
        openModal,
        closeModal,
        reviews,
        isLoading,
        error,
        hasMore,
        fetchReviews,
        sentinelRef,
    };
};
